import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'
import config from '../../config/website'

import './index.scss'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      html lang={config.siteLanguage}
      title={data.site.siteMetadata.title}
      meta charSet="utf-8" 
      link={[
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/favicons/apple-touch-icon.png' },
        { rel: 'icon', type:'image/png', sizes: '32x32', href: '/favicons/favicon-32x32.png' },
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicons/favicon-16x16.png' },
        { rel: 'shortcut icon', href: '/favicons/favicon.ico' },
      ]} 
      meta={[
        { name: 'description', content: 'This Site Totally Rules' },
        { name: 'keywords', content: 'developer, designer' },
      ]}
    />
    <Header siteTitle={data.site.siteMetadata.title} siteDescript={data.site.siteMetadata.footerdescrip} />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '35px 1.0875rem 55px',
        paddingTop: 0,
      }} className="bodystuff"
    >
    <div style={{
      paddingTop: 30,
    }}>
      {children()}
    </div>
    </div>

    <Footer siteTitle={data.site.siteMetadata.title} siteSocial={data.allSocialsitesJson.edges} />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleAndSocialsQuery {
    site {
      siteMetadata {
        title
        footerdescrip
      }
    }
    allSocialsitesJson {
      edges {
        node {
          name
          url
          id
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js